import styled, { css } from 'styled-components';

export const BoxTitleStyled = styled.div<{
  variant: 'default' | 'page' | 'base';
}>`
  align-self: flex-start;

  ${({ variant }) => {
    switch (variant) {
      case 'page':
        return css`
          margin: 64px 0 24px 0;

          @media (max-width: 650px) {
            margin: 40px 0 24px 0;
          }
        `;
      case 'base':
        return css`
          margin: 0;
        `;
      default:
        return css`
          margin: 32px 0 24px 0;
        `;
    }
  }}

  @media (max-width: 650px) {
    width: 100%;
  }

  > h1 {
    font-family: 'Inter';
    color: #000000;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    line-height: 24px;
    letter-spacing: 0em;
    margin: 0;
  }
`;
